export default __webpack_public_path__ + "static/cross-border-payment-solutions-digipay-guru-688eda1e0fa3d5a28ceeef02e2638fbf.png";